import { AspectRatio, Flex, SimpleGrid } from '@chakra-ui/react';
import Image from 'next/image';
import Item, { ITEM_WIDTHS } from './Item';
import { DashboardItem, DashboardOrder } from './types';

interface Props {
  items: DashboardItem[];
  order: DashboardOrder;
  onItemClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const MAX_SIZE = 20;

const ItemGrid = ({ items, order, onItemClick }: Props) => {
  if (!items.length) {
    return (
      <Flex py={150} width="100%" justifyContent="center" opacity={0.3}>
        <AspectRatio objectFit="cover" position="relative" width="100%" maxW="400px" ratio={2}>
          <Image src="/no-items.png" width={400} height={200} alt="No items graphic." />
        </AspectRatio>
      </Flex>
    );
  }

  return (
    <SimpleGrid mb={50} pt={50} minChildWidth={ITEM_WIDTHS} spacing="20px">
      {items.slice(0, MAX_SIZE).map((item, index) => (
        <Item key={`item-${index}`} item={item} orderItem={order.items[item.id]} onItemClick={onItemClick} />
      ))}
    </SimpleGrid>
  );
};

export default ItemGrid;
